import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment/moment';
import translate from '../../../../commonComponents/translate';

const GlobalSummary = props => {
  const { t, data } = props;

  const {
    isActive,
    isBinaryPlanActive,
    activeUntil,
    leftLegComplete,
    rightLegComplete,
    monthlyVALeft,
    monthlyVARight,
    monthlyPersonalVALeft,
    monthlyPersonalVARight,
    weeklyVALeft,
    weeklyVARight,
    weeklyAccumulatedLeft,
    weeklyAccumulatedRight,
    levelIcon,
    levelLabel,
    vaMonth,
    isCurrentWeek,
    isCurrentMonth,
  } = data;

  const getValue = value => value ?? '-';

  return (
    <>
      <div className="flex-row">
        <div className="grid-item">
          <div className="card your-level">
            <div className="card-body">
              {levelIcon ? (
                <div>
                  <img
                    src={levelIcon}
                    alt={levelLabel}
                    className="level-card-image"
                  />
                </div>
              ) : null}
              <div>
                <div className="title">
                  {isCurrentWeek || isCurrentMonth
                    ? t('profile.sidePanel.level.forecastLevel')
                    : t('report.liveoben.yourLevel')}
                </div>
                <div className="level">
                  {levelLabel || t('connect.teams.structure.no_level')}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="grid-item" style={{ flex: 1 }}>
          <div className="card card-light-gray">
            <div className="summary-card">
              <div className="summary-media">
                <img
                  src="/images/reports/user-summary.svg"
                  alt="active"
                  className="summary-image"
                />
              </div>
              <div className="summary-content">
                <div className="summary-section">
                  <span className="summary-name">
                    {t('report.arcova.summary')}
                  </span>
                </div>
                <div className="summary-action">
                  <div className="summary-action-content">
                    <span className="summary-action-label">
                      {t('report.arcova.status')}
                    </span>
                    <label htmlFor="isActive" className="checkbox">
                      <input
                        id="isActive"
                        name="isActive"
                        type="checkbox"
                        className="summary-checkbox"
                        disabled
                        checked={isActive}
                      />
                      <label htmlFor="isActive" className="fakeCheckbox" />
                      <span className="isActiveLabel">
                        {t('report.arcova.isActive')}
                      </span>
                    </label>
                  </div>
                  <div className="summary-action-content">
                    <div>
                      <span className="summary-action-label">
                        {t('report.arcova.activeUntil')}
                        <br />
                      </span>
                      <span className="summaryDate">
                        {moment(activeUntil).format('DD MMMM YYYY')}
                      </span>
                    </div>
                  </div>
                  <div className="summary-action-content">
                    <span className="summary-action-label">
                      {t('report.liveoben.binaryPlan')}
                    </span>
                    <div className="checkboxes-container">
                      <label htmlFor="binaryActive" className="checkbox">
                        <input
                          id="isBinaryActive"
                          name="isBinaryActive"
                          type="checkbox"
                          className="summary-checkbox"
                          disabled
                          checked={isBinaryPlanActive}
                        />
                        <label
                          htmlFor="isBinaryActive"
                          className="fakeCheckbox"
                        />
                        <span className="isActiveLabel">
                          {t('report.arcova.isActive')}
                        </span>
                      </label>
                      <label htmlFor="left" className="checkbox">
                        <input
                          id="left"
                          name="left"
                          type="checkbox"
                          className="summary-checkbox"
                          disabled
                          checked={leftLegComplete}
                        />
                        <label htmlFor="left" className="fakeCheckbox" />
                        <span className="isActiveLabel">
                          {t('report.liveoben.left')}
                        </span>
                      </label>
                      <label htmlFor="right" className="checkbox">
                        <input
                          id="right"
                          name="right"
                          type="checkbox"
                          className="summary-checkbox"
                          disabled
                          checked={rightLegComplete}
                        />
                        <label htmlFor="right" className="fakeCheckbox" />
                        <span className="isActiveLabel">
                          {t('report.liveoben.right')}
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="grid-item">
          <div className="card card-light-gray current-va-card">
            <div className="card-body">
              <div className="va-label">{t('report.liveoben.vaValue')}</div>
              <div className="va-value">{getValue(vaMonth)}</div>
              <div className="va-week">{t('this.month')}</div>
            </div>
          </div>
        </div>
      </div>
      <div className="level-objectives-header">
        <div className="career-section-title">
          {t('report.liveoben.monthlySummary')}
        </div>
      </div>
      <div className="pv-summary monthly-summary">
        <div className="monthly-summary-section">
          <div className="title">{t('report.liveoben.monthlyPoints')}</div>
          <div className="pv-summary">
            <div className="flex-row">
              <div className="flex-item orange-background">
                <div className="description">{t('report.liveoben.vaLeft')}</div>
                <div className="value">{getValue(monthlyVALeft)}</div>
              </div>
              <div className="flex-item blue-background">
                <div className="description">
                  {t('report.liveoben.vaRight')}
                </div>
                <div className="value">{getValue(monthlyVARight)}</div>
              </div>
            </div>
          </div>
        </div>
        <div className="monthly-summary-section">
          <div className="title">{t('report.liveoben.weeklyPoints')}</div>
          <div className="pv-summary">
            <div className="flex-row">
              <div className="flex-item orange-background">
                <div className="description">{t('report.liveoben.vaLeft')}</div>
                <div className="value">{getValue(weeklyVALeft)}</div>
              </div>
              <div className="flex-item blue-background">
                <div className="description">
                  {t('report.liveoben.vaRight')}
                </div>
                <div className="value">{getValue(weeklyVARight)}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="pv-summary monthly-summary">
        <div className="monthly-summary-section">
          <div className="title">
            {t('report.liveoben.monthlyPersonalPoints')}
          </div>
          <div className="pv-summary">
            <div className="flex-row">
              <div className="flex-item orange-background">
                <div className="description">{t('report.liveoben.vaLeft')}</div>
                <div className="value">{getValue(monthlyPersonalVALeft)}</div>
              </div>
              <div className="flex-item blue-background">
                <div className="description">
                  {t('report.liveoben.vaRight')}
                </div>
                <div className="value">{getValue(monthlyPersonalVARight)}</div>
              </div>
            </div>
          </div>
        </div>
        <div className="monthly-summary-section">
          <div className="title">{t('report.liveoben.accumulated')}</div>
          <div className="pv-summary">
            <div className="flex-row">
              <div className="flex-item orange-background">
                <div className="description">{t('report.liveoben.vaLeft')}</div>
                <div className="value">{getValue(weeklyAccumulatedLeft)}</div>
              </div>
              <div className="flex-item blue-background">
                <div className="description">
                  {t('report.liveoben.vaRight')}
                </div>
                <div className="value">{getValue(weeklyAccumulatedRight)}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

GlobalSummary.propTypes = {
  t: PropTypes.func.isRequired,
  data: PropTypes.shape({
    userId: PropTypes.string,
    isActive: PropTypes.bool,
    activeUntil: PropTypes.number,
    leftLegComplete: PropTypes.bool,
    rightLegComplete: PropTypes.bool,
    monthlyVALeft: PropTypes.number,
    monthlyVARight: PropTypes.number,
    monthlyPersonalVALeft: PropTypes.number,
    monthlyPersonalVARight: PropTypes.number,
    weeklyVALeft: PropTypes.number,
    weeklyVARight: PropTypes.number,
    weeklyAccumulatedLeft: PropTypes.number,
    weeklyAccumulatedRight: PropTypes.number,
    isBinaryPlanActive: PropTypes.bool,
    levelIcon: PropTypes.string,
    levelLabel: PropTypes.string,
    vaMonth: PropTypes.number,
    isCurrentWeek: PropTypes.bool,
    isCurrentMonth: PropTypes.bool,
  }).isRequired,
};

export default translate(GlobalSummary);
